/**
 * Icon Sliders Script
 */

import Glide from '@glidejs/glide'


document.addEventListener('DOMContentLoaded', function () {


	if ( 0 < document.querySelectorAll('.gslides-icons').length ) {

		const options = {
			type: 'carousel',
			startAt: 0,
			perView: 5,
			animationDuration: 800,
			autoplay: 3000,
			gap: 0,
			hoverpause: false
		}
	  
		const iconCarousels = document.querySelectorAll('.gslides-icons');
	  
		Object.values(iconCarousels).map(iconCarousel => {

			
			var newIconCarousel = new Glide(iconCarousel, options);

			iconCarousel.querySelector('.glide__track').setAttribute('data-glide-el', 'track');

			// Update icons showing based on window width
			function getIconsNumber() {
				let windowWidth = window.innerWidth
				let iconsShowing = 5

				if ( windowWidth < 500 ) {
					iconsShowing = 1
				} else if ( windowWidth < 600 ) {
					iconsShowing = 2
				} else if ( windowWidth < 900 ) {
					iconsShowing = 3
				} else if ( windowWidth < 1100 ) {
					iconsShowing = 4
				}

				return iconsShowing
			}

			newIconCarousel.on('build.before', function() {
	
				const arrowsWrapper = document.createElement('div')
				arrowsWrapper.className = 'glide__arrows';
				arrowsWrapper.dataset.glideEl = 'controls'
				arrowsWrapper.innerHTML = `<button class="glide__arrow glide__arrow--left" data-glide-dir="<">prev</button><button class="glide__arrow glide__arrow--right" data-glide-dir=">">next</button>`

				iconCarousel.appendChild(arrowsWrapper)

				// Update number of icons showing before mounting
				newIconCarousel.settings.perView = getIconsNumber()
	
			});
	
			newIconCarousel.mount()
		});

	}
	
}, false);